import type { StripeElementsManagerProps } from "./Props";

// Here we only need to render the children because all logic related to Stripe Elements is handled
// in `app/javascript/react/components/Paywalls/Checkout/CheckoutWithoutPMC.tsx`.
export const ManagerWithoutPMC = ({ children }: StripeElementsManagerProps) => (
  <>{children}</>
);
